import { PolicyPropertiesTab } from "~/pages/shared/policy/tabs/PolicyPropertiesTab";

export function OrganizationPolicyPropertiesTab() {
  return <PolicyPropertiesTab />;
}
